const objectContainsFalse = obj => {
  return Object.keys(obj).some(x => obj[x] === false)
}

export default objectContainsFalse
